// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const ExtraReturnType = {
  "EXTRA": "EXTRA",
  "RETURN": "RETURN"
};

const ExtraReturnStatus = {
  "NEW": "NEW",
  "APPROVED": "APPROVED",
  "CANCELED": "CANCELED",
  "WITHDRAWED": "WITHDRAWED",
  "CHECKED": "CHECKED",
  "QA_CHECKED": "QA_CHECKED",
  "WAIT_SHORTAGE": "WAIT_SHORTAGE"
};

const Department = {
  "PRODUCTION": "Production",
  "WAREHOUSE": "Warehouse",
  "QC": "QC",
  "FA": "FA",
  "PM": "PM",
  "IT": "IT",
  "PL": "PL",
  "PO": "PO",
  "RD": "RD",
  "PK": "PK",
  "QS": "QS"
};

const Division = {
  "HOUSEHOLD": "Household",
  "TOILETRY": "Toiletry"
};

const ProductionLine = {
  "MIXING": "Mixing",
  "FILLING": "Filling"
};

const BulkStatus = {
  "PASS": "PASS",
  "HOLD": "HOLD",
  "REJECT": "REJECT"
};

const OrderType = {
  "BULK": "BULK",
  "FG": "FG",
  "CLAIM": "CLAIM",
  "REPACK": "REPACK"
};

const Tag = {
  "PARTIAL": "PARTIAL",
  "TRIAL_BATCH": "TRIAL_BATCH",
  "PROMOTION": "PROMOTION"
};

const WasteRecordStatus = {
  "PD_PENDING": "PD_PENDING",
  "PD_CONFIRMED": "PD_CONFIRMED",
  "QC_APPROVED": "QC_APPROVED"
};

const FgInspectionType = {
  "PD_FILLING": "PD_FILLING",
  "PD_PACKING": "PD_PACKING",
  "QC_FILLING": "QC_FILLING",
  "QC_PACKING": "QC_PACKING"
};

const FgInspectionStatus = {
  "TESTING": "TESTING",
  "SUBMITTED": "SUBMITTED",
  "APPROVED": "APPROVED"
};

const ReceiptApprover = {
  "PD": "PD",
  "QC": "QC",
  "WH": "WH",
  "FA": "FA"
};

const MachineCategory = {
  "MIXING": "MIXING",
  "STORAGE": "STORAGE",
  "SHRINK": "SHRINK",
  "FILLING": "FILLING",
  "PLATE": "PLATE",
  "WITHPACK": "WITHPACK",
  "STICKER": "STICKER",
  "PACKING": "PACKING",
  "FILTER": "FILTER"
};

const { DgtPdProductionOrder, DgtPdOrderOperation, DgtPdOrderOperationLog, DgtPdOrderReasonCode, DgtPdDowntimeCode, DgtPdWorkCenter, DgtPdOrderPicklist, DgtPdOrderPicklistMovement, DgtPdOrderPicklistExtraReturn, DgtPdOrderPicklistExtraReturnItem, DgtPdIAMUser, DgtPdOrderInspectionLog, DgtPdOrderReceipt, DgtPdMovementReason, FGInspectionForm, FGInspectionSubmitResponse, AvgFwtByLot, FGInspectionApproveResponse } = initSchema(schema);

export {
  DgtPdProductionOrder,
  DgtPdOrderOperation,
  DgtPdOrderOperationLog,
  DgtPdOrderReasonCode,
  DgtPdDowntimeCode,
  DgtPdWorkCenter,
  DgtPdOrderPicklist,
  DgtPdOrderPicklistMovement,
  DgtPdOrderPicklistExtraReturn,
  DgtPdOrderPicklistExtraReturnItem,
  DgtPdIAMUser,
  DgtPdOrderInspectionLog,
  DgtPdOrderReceipt,
  DgtPdMovementReason,
  ExtraReturnType,
  ExtraReturnStatus,
  Department,
  Division,
  ProductionLine,
  BulkStatus,
  OrderType,
  Tag,
  WasteRecordStatus,
  FgInspectionType,
  FgInspectionStatus,
  ReceiptApprover,
  MachineCategory,
  FGInspectionForm,
  FGInspectionSubmitResponse,
  AvgFwtByLot,
  FGInspectionApproveResponse
};